import { useEffect, useState } from 'react';
import { fetchBonusTypes, deleteBonusType, addUpdateBonusType } from '../../database/databaseBonus.js';

export default function AdminBonusTypes() {
  const [bonusTypes, setBonusTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    sessions: '',
    monthbased: false,
  });

  useEffect(() => {
    (async () => {
      const data = await fetchBonusTypes();
      setBonusTypes(data || []);
    })();
  }, []);

  const fetchBonusTypesData = async () => {
    const data = await fetchBonusTypes();
    setBonusTypes(data || []);
  };

  const openModal = (row = null) => {
    setEditingId(row ? row.id : null);
    setFormData({
      name: row?.name ?? '',
      price: row?.price ?? '',
      sessions: row?.sessions ?? '',
      monthbased: !!row?.monthbased,
    });
    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    console.log('Saving bonus type with data:', formData);
    const payload = {
      name: String(formData.name).trim(),
      price: formData.price === '' ? null : Number(formData.price),
      sessions: formData.sessions === '' ? null : Number(formData.sessions),
      monthbased: !!formData.monthbased,
    };

    if (!payload.name) return alert('El nombre es obligatorio.');
    if (payload.sessions == null || Number.isNaN(payload.sessions)) return alert('Sesiones es obligatorio.');

    await addUpdateBonusType(payload, editingId);
    fetchBonusTypesData();
    setShowModal(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este tipo de bono definitivamente?')) return;
    await deleteBonusType(id);
    fetchBonusTypesData();
  };

  return (
    <section className="w-[95%] md:w-[90%] lg:w-[80%] mx-auto py-6">
      {/* Header */}
      <div className="flex flex-wrap gap-3 items-center justify-end mb-4">
        <button onClick={() => openModal()} className="bg-terracotta text-cream px-4 py-2 rounded hover:bg-terracotta-dark transition w-full sm:w-auto">
          Nuevo Tipo de Bono
        </button>
      </div>

      <div className="hidden md:block overflow-x-auto rounded border border-sand">
        <table className="w-full table-fixed border-collapse text-sm">
          <colgroup>
            <col style={{ width: '30%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
          </colgroup>
          <thead>
            <tr className="bg-sand text-left text-terracotta-dark">
              <th className="border px-3 py-2">Nombre</th>
              <th className="border px-3 py-2">Precio</th>
              <th className="border px-3 py-2">Sesiones</th>
              <th className="border px-3 py-2 text-center">Fijo</th>
              <th className="border px-3 py-2 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {bonusTypes.map((row) => (
              <tr key={row.id} className="hover:bg-sand/40">
                <td className="border px-3 py-2 align-top break-words">{row.name}</td>
                <td className="border px-3 py-2 align-top whitespace-nowrap">{row.price}</td>
                <td className="border px-3 py-2 align-top text-center">{row.sessions}</td>
                <td className="border px-3 py-2 align-top text-center">{row.monthbased ? 'Sí' : 'No'}</td>
                <td className="border px-3 py-2 align-top text-center">
                  <div className="flex items-center justify-center gap-3">
                    <button onClick={() => openModal(row)} className="text-blue-600 hover:underline">
                      Editar
                    </button>
                    <button onClick={() => handleDelete(row.id)} className="text-red-600 hover:underline">
                      Borrar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {bonusTypes.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  No hay registros.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile / Small screens: Card list (< md) */}
      <div className="md:hidden space-y-3">
        {bonusTypes.length === 0 && <div className="text-center py-4 border border-sand rounded">No hay registros.</div>}

        {bonusTypes.map((row) => (
          <div key={row.id} className="border border-sand rounded-lg p-4 shadow-sm bg-card">
            <div className="flex flex-col gap-2">
              {/* Name */}
              <div className="flex gap-2">
                <span className="w-[40%] text-sm font-medium text-ink/70">Nombre</span>
                <span className="w-[60%] break-words">{row.name}</span>
              </div>
              {/* Price */}
              <div className="flex gap-2">
                <span className="w-[40%] text-sm font-medium text-ink/70">Precio</span>
                <span className="w-[60%] whitespace-nowrap">{row.price}</span>
              </div>
              {/* Sessions */}
              <div className="flex gap-2">
                <span className="w-[40%] text-sm font-medium text-ink/70">Sesiones</span>
                <span className="w-[60%]">{row.sessions}</span>
              </div>
              {/* Fixed */}
              <div className="flex gap-2">
                <span className="w-[40%] text-sm font-medium text-ink/70">Fijo</span>
                <span className="w-[60%]">{row.monthbased ? 'Sí' : 'No'}</span>
              </div>
            </div>

            <div className="mt-4 flex justify-between">
              <button onClick={() => openModal(row)} className="px-3 py-2 rounded border w-[48%] text-blue-700 border-blue-200">
                Editar
              </button>
              <button onClick={() => handleDelete(row.id)} className="px-3 py-2 rounded border w-[48%] text-red-700 border-red-200">
                Borrar
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-card p-6 rounded-lg w-[96%] sm:w-[85%] md:w-[70%] lg:w-[50%] xl:w-[40%] max-w-[900px] shadow-lg">
            <h3 className="text-lg sm:text-xl font-serif text-terracotta mb-4">{editingId ? 'Editar tipo de bono' : 'Agregar nuevo tipo de bono'}</h3>
            <form onSubmit={handleSave} className="space-y-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <label className="block w-full sm:w-[50%]">
                  <span className="text-sm font-medium">Nombre</span>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full border border-sand bg-cream text-ink px-3 py-2 rounded"
                    required
                  />
                </label>
                <label className="block w-full sm:w-[50%]">
                  <span className="text-sm font-medium">Precio</span>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.price}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                    className="w-full border border-sand bg-cream text-ink px-3 py-2 rounded"
                  />
                </label>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <label className="block w-full sm:w-[50%]">
                  <span className="text-sm font-medium">Sesiones</span>
                  <input
                    type="number"
                    value={formData.sessions}
                    onChange={(e) => setFormData({ ...formData, sessions: e.target.value })}
                    className="w-full border border-sand bg-cream text-ink px-3 py-2 rounded"
                    required
                  />
                </label>

                <label className="flex items-center gap-2 w-full sm:w-[50%] mt-2 sm:mt-8">
                  <input
                    type="checkbox"
                    checked={formData.monthbased}
                    onChange={(e) => setFormData({ ...formData, monthbased: e.target.checked })}
                    className="h-4 w-4"
                  />
                  <span className="text-sm font-medium">Añadir Clases Automáticamente (Fijo)</span>
                </label>
              </div>

              <div className="flex justify-end gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 rounded border border-sand text-ink hover:bg-sand/40 w-[45%] sm:w-auto">
                  Cancelar
                </button>
                <button type="submit" className="bg-terracotta text-cream px-4 py-2 rounded hover:bg-terracotta-dark transition w-[45%] sm:w-auto">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
